import React from "react";
import { Link } from "react-router-dom";
// import Info from "../../files/Info_en.json";

const Home_Contacts = () => {
  return (
    <section className="lkbxbg5 container py-5">
      <h2 className="text-center fw-bold mb-4">Contacts</h2>
      <div className="row text-center">
        <div className="col-md-1"></div>
        <div className="col-md-2">
          <Link to="contacts" title="londonkickboxing contact page">
            <span className="text-white glyphicon glyphicon-envelope fa-5x"></span>
          </Link>
          {/* <h5>Contacts</h5> */}
        </div>
        <div className="col-md-2">
          <a href="tel:+447779593335" title="Call us now!">
            <span className="text-white glyphicon glyphicon-phone fa-5x"></span>
          </a>
          {/* <h5>Call Us</h5> */}
        </div>
        <div className="col-md-2">
          <a
            href="https://www.youtube.com/user/asmartialarts"
            target="_blank"
            rel="noreferrer"
            title="www.youtube.com/asmartialarts"
          >
            <img
              src="/img/youtube.png"
              alt="youtube"
              className="img-responsive img-centered"
              width="90"
            />
          </a>
          {/* <h5>Youtube</h5> */}
        </div>
        <div className="col-md-2">
          <a
            href="https://www.facebook.com/londonkickboxing"
            target="_blank"
            rel="noreferrer"
            title="www.facebook.com/londonkickboxing"
          >
            <img
              src="/img/facebook.png"
              alt="facebook"
              className="img-responsive img-centered"
              width="90"
            />
          </a>
          {/* <h5>Facebook</h5> */}
        </div>
        <div className="col-md-2">
          <a
            href="https://www.instagram.com/londonkickboxing/"
            target="_blank"
            rel="noreferrer"
            title="www.instagram.com/londonkickboxing"
          >
            <img
              src="/img/instagram.png"
              alt="instagram"
              className="img-responsive img-centered"
              width="110"
            />
          </a>
          {/* <h5>Instagram</h5> */}
        </div>
      </div>
    </section>
  );
};

export default Home_Contacts;
